var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirtualgame({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_703_561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4188 15.3058L14.2415 13.9136C13.1525 15.0666 11.6195 15.8008 10 15.8008C8.38052 15.8008 6.84751 15.0668 5.7585 13.9138L1.58125 15.3061C0.712256 15.5965 0 16.5838 0 17.5V20H20V17.5C20 16.5838 19.2888 15.5965 18.4188 15.3058Z",
    fill: "#6B758B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 4.16675H4.99976C4.0835 4.16675 3.33301 4.91699 3.33301 5.8335V8.3335C3.33301 9.24976 4.0835 10 4.99976 10H14.9998C15.916 10 16.6665 9.24976 16.6665 8.33325V5.83325C16.6665 4.91699 15.916 4.16675 14.9998 4.16675ZM6.6665 7.5H4.99976V5.83325H6.6665V7.5Z",
    fill: "#6B758B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04785 11.25C6.61187 12.8825 8.26484 14.134 9.99985 14.134C11.7349 14.134 13.3878 12.8825 13.9519 11.25H6.04785Z",
    fill: "#6B758B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 0C7.82739 0 6.12139 1.17827 5.39014 2.91675H14.6102C13.8796 1.17827 12.1722 0 10.0001 0Z",
    fill: "#6B758B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_703_561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualgame);
export default __webpack_public_path__ + "static/media/virtual game.bdcb9c9507a1a5673be03e869851c029.svg";
export { ForwardRef as ReactComponent };